"use client";

import { AnimatePresence, motion, useReducedMotion } from "framer-motion";
import type { PropsWithChildren, ReactNode } from "react";
import {
  PUBLIC_ENTRANCE_BANNER_REDUCED_VARIANTS,
  PUBLIC_ENTRANCE_BANNER_VARIANTS,
  PUBLIC_ENTRANCE_EASE,
  PUBLIC_ENTRANCE_REDUCED_VARIANTS,
  PUBLIC_ENTRANCE_VARIANTS,
} from "./publicEntranceConfig";

interface PublicEntranceBannerProps {
  show: boolean;
  children: ReactNode;
}

export function PublicEntranceBanner({
  show,
  children,
}: PublicEntranceBannerProps) {
  const reduceMotion = useReducedMotion();
  const variants = reduceMotion
    ? PUBLIC_ENTRANCE_BANNER_REDUCED_VARIANTS
    : PUBLIC_ENTRANCE_BANNER_VARIANTS;

  return (
    <AnimatePresence initial={false}>
      {show ? (
        <motion.div
          key="banner"
          initial="hidden"
          animate="visible"
          exit="exit"
          variants={variants}
          style={{ overflow: "hidden" }}
        >
          {children}
        </motion.div>
      ) : null}
    </AnimatePresence>
  );
}

interface PublicEntranceScaleProps extends PropsWithChildren {
  className?: string;
}

/** Fade + subtle scale for success / confirmation states. */
export function PublicEntranceScale({
  children,
  className,
}: PublicEntranceScaleProps) {
  const reduceMotion = useReducedMotion();
  const variants = reduceMotion
    ? PUBLIC_ENTRANCE_REDUCED_VARIANTS
    : PUBLIC_ENTRANCE_VARIANTS.scale;

  return (
    <motion.div
      className={className}
      initial="hidden"
      animate="visible"
      variants={variants}
      transition={{ duration: 0.42, ease: PUBLIC_ENTRANCE_EASE }}
    >
      {children}
    </motion.div>
  );
}
